import { Component } from "react";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { ACCOUNT_DISCONNECT, SELECT_ACCOUNT } from "../../../../../../actions/addFeedActions";
import ProfileImage from "./ProfileImage";
import { FontAwesomeIcon } from "../../../../../CommonComponents/AssetsHelper";

class AccountPicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedAccount: props.connectedAcc[0],
            accounts: []
        }
    }

    componentDidMount() {
        const { selectAccount, personalAccount, personal, connectedAcc } = this.props;
        setTimeout(() => {
            if (connectedAcc && connectedAcc.length) {
                this.props.onConnectedAccountChange(this.props.connectedAcc[0].ConnectedAccounts.id)
                selectAccount(this.props.connectedAcc[0].ConnectedAccounts.id)
                this.setState({ accounts: personal ? personalAccount : connectedAcc, selectedAccount: personal ? personalAccount[0] : connectedAcc[0] })
            }
        }, 500);
    }


    disconnectAccount = (account) => {
        const obj = {
            "account": account.ConnectedAccounts.id,
            "networkId": account.ConnectedAccounts.networkId
        }
        const {accounts} = this.state;
        this.props.disconnectAccount(obj,()=>{
            if( accounts.length-1 >= 1){
                const updateAccountsList = accounts.filter(acc=>acc.ConnectedAccounts.id !== account.ConnectedAccounts.id);
                this.props.onConnectedAccountChange(updateAccountsList[0].ConnectedAccounts.id);
                this.props.selectAccount(updateAccountsList[0].ConnectedAccounts.id);
                this.setState({ accounts: updateAccountsList,selectedAccount:updateAccountsList[0] })
            }else{
                this.props.selectAccount(null);
                this.props.onConnectedAccountChange(null);
            }
           });
    }

    deleteAccount = (account) => {
        Swal.fire({
            title: '<strong>Confirm</strong>',
            icon: 'warning',
            text:
                'Do you want to disconnect account?',
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: true,
            confirmButtonText:
                'Yes',
            confirmButtonAriaLabel: 'Yes',
            cancelButtonAriaLabel: 'Thumbs down'
        }).then((result) => {
            if (result.value) {
                this.disconnectAccount(account)
            }
            else if (result.dismiss === "cancel") { }
        })
    }

    onAccountChange = (id) => {
        this.props.selectAccount(id ? id : null)
        this.props.onConnectedAccountChange(id);
        if(!id){
            this.setState({ selectedAccount: null });
        }
    }

    render() {
        const { selectedAccount, accounts } = this.state

        return (
            <>
                {accounts && accounts.length ? <Dropdown className="w-100 connected_acc__" id="connectedAll">
                    <Dropdown.Toggle variant="" className="p-2 w-100 border f-between mt-3">
                        <span className="navi-link d-flex align-items-center justify-content-between cursor-pointer m-0 w-100" >
                            <div className="user_id d-flex align-items-center justify-content-start conndAcc_popuphover accountProfile">
                                <span className="symbol symbol-circle account-picker symbol-35 me-2">
                                    {
                                        selectedAccount ?

                                            <ProfileImage key={`${selectedAccount.ConnectedAccounts.accountName}_${selectedAccount.ConnectedAccounts.id}`} pic={selectedAccount.ConnectedAccounts.profilePicture} accountName={selectedAccount.ConnectedAccounts.accountName} network={selectedAccount.Network.name} />
                                            :
                                            <span style={{color:"#d3d6db"}}><FontAwesomeIcon type={'solid'} icon={'circle-user'} iconClass={'fs-1'} /></span>
                                    }
                                </span>
                                <div className="font-weight-bold conn_user_name text-dark">{selectedAccount ? selectedAccount.ConnectedAccounts.accountName : 'Add Another Account'}</div>
                            </div>
                            <input type="radio" id="" className="accountOption d-none" />
                        </span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="w-100 navi flex-column navi-hover py-2 connectedAllAccounts">
                        <div className="navi flex-column navi-hover py-1 px-3 connectedAllAccounts">Select Account:</div>
                        {accounts && accounts.length ? accounts.map(acc => (
                            <Dropdown.Item className="navi-item" key={acc.ConnectedAccounts.accountId} onClick={() => { this.setState({ selectedAccount: acc }, () => this.onAccountChange(acc.ConnectedAccounts.id)); }}>
                                <span className="navi-link d-flex align-items-center justify-content-between cursor-pointer m-0 w-100" >
                                    <div className="user_id d-flex align-items-center justify-content-start conndAcc_popuphover accountProfile">
                                        <span className="symbol symbol-circle account-picker symbol-35 me-3">
                                            <ProfileImage key={`${acc.ConnectedAccounts.accountName}_${acc.ConnectedAccounts.id}`} pic={acc.ConnectedAccounts.profilePicture} accountName={acc.ConnectedAccounts.accountName} network={acc.Network.name} />
                                        </span>
                                        <div className="font-weight-bold conn_user_name text-dark">{acc.ConnectedAccounts.accountName}</div>
                                    </div>
                                    <span id="" className="cursor-pointer" onClick={() => this.deleteAccount(acc)}>
                                        <FontAwesomeIcon type={'light'} icon={'circle-xmark'} iconClass={'fs-3 text-secondary'}/>
                                    </span>
                                    <input type="radio" id="" className="accountOption d-none" />
                                </span>
                            </Dropdown.Item>
                        ))
                            : null
                        }
                        <Dropdown.Item className="navi-item" onClick={() => { this.onAccountChange(); this.setState({ selectedAccount: null }) }}>
                            <span className="navi-link d-flex align-items-center justify-content-between flex-wrap cursor-pointer m-0 forAddNew accountProfile w-100" htmlFor="otherAccount">
                                <div className="user_id d-flex align-items-center justify-content-start conndAcc_popuphover accountProfile">
                                    <span style={{color:"#d3d6db"}}>
                                        <FontAwesomeIcon type={'solid'} icon={'circle-user'} iconClass={'fs-1 me-4'}/>
                                    </span>
                                    <div className="font-weight-bold conn_user_name text-dark">Add Another Account</div>
                                </div>
                                <FontAwesomeIcon type={'light'} icon={'circle-plus'} iconClass={'fs-3 text-secondary'}/>
                                <input type="radio" id="otherAccount" className="accountOption d-none" />
                            </span>
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
                    :
                    null
                }

            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        accountId: state.addFeedReducer.selectedAccount
    }
}

const mapDispatchToProps = dispatch => {
    return {
        disconnectAccount: (obj,callback) => dispatch(ACCOUNT_DISCONNECT(obj,callback)),
        selectAccount: (obj) => dispatch(SELECT_ACCOUNT(obj)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountPicker)